import { Button, Grid, Hidden, Typography, styled, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Mousewheel, Navigation, Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import FilterCard from '../../../../components/cards/filterCard';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

// Actions
import { resetFiltersAction, updateFiltersAction } from '../../../../store/actions/shopByActions';

// Routes
import { appRoutes } from '../../../../routes/appRoutes';

const HeaderSection = styled(Grid)(({ theme, filters, isHomeView, isMobile }) => ({
  position: 'relative',
  background: `url(${filters.backgroundImage}) no-repeat center center`,
  backgroundSize: 'cover',
  color: theme.palette.common.white,
  maxWidth: isMobile ? '100vw' : '82vw',
  margin: 'auto',
  textAlign: 'start',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(4, 4),
  '&::after': {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.65)',
    mixBlendMode: 'multiply',
    pointerEvents: 'none',
    zIndex: -1,
    textAlign: 'start',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));
const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '27px',
    color: 'var(--Neutrals-Black, #fff)'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '40px',
    color: 'var(--Neutrals-Black, #fff)'
  }
}));
const Description = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  [theme.breakpoints.down('md')]: {
    marginBottom: '8px',
    marginTop: '8px'
  },
  [theme.breakpoints.up('md')]: {
    marginBottom: '32px'
  }
}));

const StyledButton = styled(Button)(({ theme }) => ({
  border: '2px solid white',
  color: 'white',
  textAlign: 'center',
  fontSize: '14px',
  fontWeight: 700,
  fontFamily: 'Inter'
}));

const swiperSettings = {
  breakpoints: {
    1800: {
      slidesPerView: 8.2
    },
    1400: {
      slidesPerView: 6.2
    },
    1300: {
      slidesPerView: 5.6
    },
    1100: {
      slidesPerView: 4.8
    },
    1000: {
      slidesPerView: 4.2
    },
    800: {
      slidesPerView: 3.8
    },
    700: {
      slidesPerView: 3.6
    },
    600: {
      slidesPerView: 3.2
    },
    400: {
      slidesPerView: 1.8
    },
    200: {
      slidesPerView: 1.6
    }
  }
};

const ShopByActivityHome = ({ filters }) => {
  // Navigate
  const navigate = useNavigate();

  // Dispatch
  const dispatch = useDispatch();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Handlers
  function getTitleById(selectedId) {
    const category = filters.categories.find((c) => c.id === selectedId);
    return category ? category.title : 'Category not found';
  }

  const handleCardClick = (id) => {
    dispatch(resetFiltersAction());
    const updatedFilters = {
      page: 1,
      pageSize: 10,
      Activity: getTitleById(id),
    };
    dispatch(updateFiltersAction(updatedFilters));
    navigate(appRoutes.shopByActivity);
  };

  const handleBrowseAllActivities = () => {
    dispatch(resetFiltersAction());
    navigate(appRoutes.shopByActivity);
  };

  return (
    <HeaderSection container filters={filters} isMobile={isMobile}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item justifyContent={'start'} justifyItems={'start'}>
          <Title>EXPLORE BY ACTIVITY</Title>
          <Description>Pair products with your activities to enhance the brain chemistry you want to achieve. </Description>
        </Grid>
        <Hidden smDown>
          <Grid item>
            <StyledButton onClick={() => handleBrowseAllActivities()}>BROWSE ALL ACTIVITIES</StyledButton>
          </Grid>
        </Hidden>
      </Grid>
      <Grid container spacing={1} item mt={6} display={'flex'} maxWidth={isMobile ? '100%' : '100%'} justifyContent={'center'} sx={{ overflow: 'hidden' }}>
        <Swiper {...swiperSettings} modules={[Scrollbar, Mousewheel, Navigation]} scrollbar={{ draggable: true }} mousewheel={true} direction='horizontal' navigation style={{ "--swiper-navigation-color": "white", }}>
          {filters.categories.map((category, index) => (
            <SwiperSlide key={index}>
              <Grid item key={category.id} style={{ marginBottom: '20px', marginLeft: '15px' }}>
                <FilterCard title={category.title} image={category.image} onClick={() => handleCardClick(category.id)} isSelected={null} />
              </Grid>
            </SwiperSlide>
          ))}
        </Swiper>
      </Grid>
      <Hidden mdUp>
        <Grid item mt={2} xs={12} textAlign={'center'}>
          <StyledButton onClick={() => handleBrowseAllActivities()} fullWidth>
            BROWSE ALL ACTIVITIES
          </StyledButton>
        </Grid>
      </Hidden>
    </HeaderSection>
  );
};

export default ShopByActivityHome;
